import React from 'react';
import EntityForm from './EntityForm';

function AdditionalWorkForm({ onChanged, selectedEntry = null, setSelectedEntry }) {
    return (
        <EntityForm
            noun="Additional Work"
            heading="Add New Additional Work"
            insertUrl="insert_additional_work"
            fields={[
                { name: 'name', label: 'Additional Work Name', required: true },
            ]}
            selectedEntry={selectedEntry}
            setSelectedEntry={setSelectedEntry}
            onChanged={onChanged}
        />
    );
}

export default AdditionalWorkForm;
